//genest.io account
// const config = {
//   identityPoolId: 'us-west-2:59e95598-c758-44c3-b818-3c7a5e03faef',
//   region: 'us-west-2',
//   userPoolId: 'us-west-2_7ruS8Li0I',
//   appClient: '7na6j50u3u925q79khn8tpevll',
//   appSyncEndpoint: 'https://zxq25try3vdmxll7tgkyf4gtqe.appsync-api.us-west-2.amazonaws.com/graphql'
// }
// pop-art account
const config = {
  identityPoolId: 'us-west-2:0de9c14a-2714-4928-81a7-6e7c3ff8e4d9',
  region: 'us-west-2',
  userPoolId: 'us-west-2_2s4UsyNB1',
  appClient: '4hbt2edm51fgbhb9cmik2eoi2b',
  appSyncEndpoint: 'https://jotu5hgehrdevfppngeiw4xwqa.appsync-api.us-west-2.amazonaws.com/graphql'
}

export default config



// WEBPACK FOOTER //
// ./src/config.js